import axios from "axios";
import config from "../../config";
import router from "@/router";

const state = {
  token: localStorage.getItem("user-token") || "",
  refreshToken: localStorage.getItem("refresh-token") || "",
  userPhoneActivateToken:
    localStorage.getItem("user-phone-activate-token") || "",
  userPhoneHidden: localStorage.getItem("user-phone-hidden") || "",
  confirmPhone: localStorage.getItem("confirm-phone") || "Y",
  confirmRules: localStorage.getItem("confirm-rules") || "Y",
  tempPassword: localStorage.getItem("temp-password") || "N",
  status: ""
};

const getters = {
  getConfirmRules: state => state.confirmRules === "Y",
  getConfirmPhone: state => state.confirmPhone === "Y",
  getTempPassword: state => state.tempPassword === "Y",
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  getToken: state => state.token,
  getRefreshToken: state => state.refreshToken
};

const actions = {
  authRequest: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      commit("authRequest");
      axios({
        url: config.backend_url + "users/login",
        data: user,
        method: "POST"
      })
        .then(resp => {
          let data = resp.data;
          console.log(data);
          if (data.token) {
            commit("authSuccess", data);
            dispatch("user/userRequest", data.userData, { root: true });
            if (data.notSignedRules) commit("notConfirmRules");
            if (data.tempPassword) commit("tempPassword");
            if (data.notConfirm) {
              commit("notConfirmPhone", data);
              router.push("/confirm-phone").then(() => {});
            }
            resolve(data);
          } else {
            reject("Неверные телефон и пароль");
          }
        })
        .catch(err => {
          commit("authError", err);
          localStorage.removeItem("user-token");
          reject(err);
        });
    });
  },
  authLogout: ({ commit }) => {
    return new Promise(resolve => {
      commit("authLogout");
      commit("user/authLogout", {}, { root: true });
      router.push("/login").then(() => resolve());
    });
  }
};

const mutations = {
  authRequest: state => {
    state.status = "loading";
  },
  notConfirmPhone: (state, resp) => {
    state.userPhoneActivateToken = resp.phoneConfirmToken;
    state.userPhoneHidden = resp.hiddenPhone;
    state.confirmPhone = "N";
    localStorage.setItem("confirm-phone", "N");
    localStorage.setItem("user-phone-hidden", resp.hiddenPhone);
    localStorage.setItem("user-phone-activate-token", resp.phoneConfirmToken);
  },
  confirmPhone: state => {
    state.confirmPhone = "Y";
    localStorage.setItem("confirm-phone", "Y");
  },
  notTempPassword: state => {
    state.tempPassword = "N";
    localStorage.setItem("temp-password", "N");
  },
  tempPassword: state => {
    state.tempPassword = "Y";
    localStorage.setItem("temp-password", "Y");
  },
  notConfirmRules: state => {
    state.confirmRules = "N";
    localStorage.setItem("confirm-rules", "N");
  },
  confirmRules: state => {
    state.confirmRules = "Y";
    localStorage.setItem("confirm-rules", "Y");
  },
  authSuccess: (state, resp) => {
    state.status = "success";
    state.token = resp.token;
    state.refreshToken = resp.refreshToken;
    localStorage.setItem("user-token", resp.token);
    localStorage.setItem("refresh-token", resp.refreshToken);
  },
  authError: state => {
    state.status = "error";
  },
  authLogout: state => {
    state.token = "";
    state.refreshToken = "";
    localStorage.removeItem("user-token");
    localStorage.removeItem("refresh-token");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
